module.exports = __webpack_public_path__ + "img/8.95ed1c3b.jpg";